import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8f297b74"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "pop-up-comp mask"
};
const _hoisted_2 = {
  class: "inner-content"
};
const _hoisted_3 = {
  class: "title color_text_1"
};
const _hoisted_4 = {
  class: "btn-ara"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.visible && $props.config.text ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
    class: "icon-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.cancel && $setup.cancel(...args))
  }), _createElementVNode("div", _hoisted_3, _toDisplayString($props.config.text), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "cancel btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.cancel && $setup.cancel(...args))
  }, _toDisplayString($props.config.cancelButtonText || '取消'), 1), _createElementVNode("div", {
    class: "confirm btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.confirm && $setup.confirm(...args))
  }, _toDisplayString($props.config.confirmButtonText || '确认'), 1)])])])) : _createCommentVNode("", true);
}